module.exports = __webpack_public_path__ + "static/media/CBCP-JZ.556cbb12.png";